module.exports = __webpack_public_path__ + "img/check-bg.6a71ab0f.png";